import { Component } from "react";
import LandingSearchHeader from "../part/header_search";
import FloatingContact from "../part/floating.contact";
import LandingFooter from "../part/landing.footer";
import axios from "axios";
import { Link } from "react-router-dom";
import LoadingError from "../part/loading_error";
import NetworkIssue from "../part/network";
import { SlSocialDropbox } from "react-icons/sl";
import { Helmet } from "react-helmet-async";


class SingleBlog extends Component {
    state = {
        loading: false,
        network: false,
        role: "",
        blog: [],
        singleBlog: {}, // ✅ Changed to object for correct access

    }
    componentDidMount() {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const User = JSON.parse(storedUser);
                this.setState({ role: User.role })
            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
            }
        }

        // ✅ ADDITION: Fetch data on mount
        this.fetchBlogs();
    }


    // ✅ fetchBlogs looks correct
    fetchBlogs = async () => {
        this.setState({ loading: true })
        const accessToken = localStorage.getItem("accessToken");
        let headers = {};

        if (accessToken) {
            headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        }

        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/blogs/", {
                headers: headers,
            });
            this.setState({ blog: response.data, loading: false });
            if (response.data) {
                this.SingleBlogFilter(response.data)
            }

        } catch (error) {
            console.error("Submission error:", error);
            let errorMessage = "Network error or server unavailable.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.detail || JSON.stringify(error.response.data);
            } else if (error.code === "ERR_NETWORK") {
                this.setState({ network: true });
            }
            this.setState({ error: errorMessage });

            setTimeout(() => {
                this.setState({ error: null });
            }, 5000);

        } finally {
            this.setState({ loading: false });
        }
    }


    // ✅ Corrected to use find() and set singleBlog as an object
    SingleBlogFilter = (blog) => {
        const id = this.props.blogId
        console.log("single information start with the id ", id, blog)
        const singleBlog = blog.find(list =>
            String(list.id) === String(id.id)
        )
        console.log("the particular blog", singleBlog)
        this.setState({
            singleBlog: singleBlog || {}
        })

    }

    // ✅ Corrected to return the filtered array and exclude the current post
    relatedBlogFilter = () => {
        const { singleBlog, blog } = this.state
        if (!singleBlog || !singleBlog.label) return [];

        return blog.filter(list => (
            list.label === singleBlog.label && list.id !== singleBlog.id
        ))
    }


    // ✅ Implemented functionality to replace # with <br/> and return for dangerouslySetInnerHTML
    MainParagraph = () => {
        const { singleBlog } = this.state
        if (!singleBlog.description) return { __html: "" };

        const htmlContent = singleBlog.description.replace(/#/g, '<br/>');
        return { __html: htmlContent };
    }


    handleRedirectEdit = () => {
        const { singleBlog } = this.state;
        localStorage.setItem("GeoacademyBlogPost", JSON.stringify(singleBlog));

        this.props.redirect();
    }



    render() {
        const { role, singleBlog, loading, network } = this.state
        const relatedBlog = this.relatedBlogFilter()
        const blogList = relatedBlog.length > 0 ? relatedBlog.map(list => {
            return (
                <section className="blog-card-contain" key={list.id}>
                    <div className="card-image">
                        <img src={list.image} alt={list.title} />
                    </div>
                    <div className="card-content">
                        <h4>{list.title}</h4>
                        <p>{list.narration}</p>
                    </div>
                </section>
            )
        }) : <div className="error_message">
            <SlSocialDropbox />
            <p>No Related Blog Post</p>
        </div>



        return (
            <>
                <Helmet key={singleBlog.id || "default"}>
                    <title>{singleBlog.seo_title ? `${singleBlog.seo_title} | GeoInfo Academy` : "Geoacademy Blog"}</title>
                    <meta
                        name="description"
                        content={
                            singleBlog.seo_description ||
                            singleBlog.narration ||
                            "GeoInfoAcademy Professional Blog Page"
                        }
                    /> 

                    <meta property="og:title" content={singleBlog.seo_title} />
                    <meta property="og:description" content={singleBlog.seo_description || singleBlog.description} />
                    <meta property="og:image" content={singleBlog.image} />
                    <meta property="og:type" content="article" />
                    <meta property="og:url" content={`https://geoinfoacademy.com/blog/${singleBlog.id}`} />
                </Helmet>


                <div className="body">
                    <LandingSearchHeader />
                    <div className="blog_cover">
                        <div className="blog_container flex" style={{ flexDirection: "unset", margin: "100px 0px 0px" }}>
                            <Link to="/blog"><button className="nav_button">Back</button></Link>
                            {role === "tutor" && <button className="nav_button" onClick={() => this.handleRedirectEdit()} >Edit</button>}
                        </div>
                        <div className="blog_container flex">

                            <section className="blog_single_cover">
                                <h2>
                                    <span>{singleBlog.label}</span><br />
                                    {singleBlog.title}
                                </h2>
                                <h3>{singleBlog.narration}</h3>
                                <div className="blog_image">
                                    {/* ✅ Correction: Render the image using an <img> tag */}
                                    {singleBlog.image && <img src={singleBlog.image} alt={singleBlog.title} />}
                                </div>
                                <p>
                                    {/* ✅ Correction: Use dangerouslySetInnerHTML to render the description with <br/> tags */}
                                    <span dangerouslySetInnerHTML={this.MainParagraph()} />
                                </p>

                            </section>
                            <section className="blog_single_list_cover">
                                <h3>Related Topic</h3>
                                <div className="blog_single_list_container">

                                    {blogList}

                                </div>
                            </section>

                        </div>
                    </div>
                    <FloatingContact />
                    <LandingFooter />

                    {loading ? <LoadingError /> : null}
                    {network ? <NetworkIssue /> : null}
                </div>
            </>
        )
    }
}


export default SingleBlog